'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface Row {
	title: string
	text: string
	imageDesktop: string
	imageTablet: string
	imageMobile: string
}

// ЗАГЛУШКИ: пути к картинкам (по 3 варианта на строку) и тексты — заменить на свои
const rows: Row[] = [
	{
		title: 'Изолированный контур',
		text: 'Сотрудники получают доступ только к функции переводов физическим лицам. Они видят изолированный баланс бизнес-карты и не имеют доступа к основному счёту компании.',
		imageDesktop: '/images/b2c/b2csolution_row1_desktop.png',
		imageTablet: '/images/b2c/b2csolution_row1_tablet.png',
		imageMobile: '/images/b2c/b2csolution_row1_mobile.png'
	},
	{
		title: 'Для любого устройства',
		text: 'Сервис работает прямо в браузере смартфона, планшета или ПК. Для проведения выплаты менеджеру или кассиру больше не нужен токен, USB-ключ или присутствие руководителя.',
		imageDesktop: '/images/b2c/b2csolution_row2_desktop.png',
		imageTablet: '/images/b2c/b2csolution_row2_tablet.png',
		imageMobile: '/images/b2c/b2csolution_row2_mobile.png'
	},
	{
		title: 'По всей России',
		text: 'Сервис обеспечивает отправку переводов на карты физических лиц по всей России. Управляйте выплатами сети филиалов, касс или франшиз из единого личного кабинета.',
		imageDesktop: '/images/b2c/b2csolution_row3_desktop.png',
		imageTablet: '/images/b2c/b2csolution_row3_tablet.png',
		imageMobile: '/images/b2c/b2csolution_row3_mobile.png'
	}
]

const B2cSolution: React.FC = () => {
	return (
		<section className={styles.b2cSolution}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.subtitle}>Решение True.pay B2C</div>
				<h2
					className={styles.title}
					dangerouslySetInnerHTML={{ __html: '<span>Безопасные переводы</span><br>с бизнес‑карт за пару кликов' }}
				/>
			</AnimatedSection>
			<div className={styles.sections}>
				{rows.map((row, index) => (
					<AnimatedSection key={index} animation='slideUp' className={styles.row}>
						<div className={styles.rowText}>
							<h3 className={styles.sectionTitle}>{row.title}</h3>
							<p className={styles.text} dangerouslySetInnerHTML={{ __html: row.text }} />
						</div>
						<div className={styles.rowImage}>
							<Image
								src={row.imageDesktop}
								alt={row.title}
								width={635}
								height={440}
								className={styles.desktopImage}
								unoptimized
							/>
							<Image
								src={row.imageTablet}
								alt={row.title}
								width={680}
								height={440}
								className={styles.tabletImage}
								unoptimized
							/>
							<Image
								src={row.imageMobile}
								alt={row.title}
								width={328}
								height={212}
								className={styles.mobileImage}
								unoptimized
							/>
						</div>
					</AnimatedSection>
				))}
			</div>
		</section>
	)
}

B2cSolution.displayName = 'B2cSolution'

export default B2cSolution
